import { MedicalDataAccessAuthorization, PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

type Item = PatientConsentDocument | MedicalDataAccessAuthorization;

const isMedicalDataAccessAuthorization = (item: Item): item is MedicalDataAccessAuthorization => {
   return 'externalIdentifier' in item || 'birthDate' in item;
};

export const patientConsentsAndAuthorizationVisitor = (item: Item) => <ACCEPT>(visitor: {
   forConsent: (patientConsentDocument: PatientConsentDocument) => ACCEPT;
   forAuthorization: (patientAuthorization: MedicalDataAccessAuthorization) => ACCEPT;
}) => {
   if (isMedicalDataAccessAuthorization(item)) {
      return visitor.forAuthorization(item);
   }
   return visitor.forConsent(item);
};

const getDate = (item: Item): Date => ('creationDate' in item ? new Date(item.creationDate) : new Date(item.enterDate));

export const consentsAndAuthorizationsSortByDate = (consentsAndAuthorizations: Array<Item>): Array<Item> => {
   return consentsAndAuthorizations.sort(
      (consentAndAuthorizationA, consentAndAuthorizationB) =>
         getDate(consentAndAuthorizationB).getTime() - getDate(consentAndAuthorizationA).getTime()
   );
};
